export default __webpack_public_path__ + "static/media/picture_image.ac1b2e37.svg";